import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import MaintainerDetailScreen from './screens/MaintainerDetailScreen';
import MaintainerListScreen from './screens/MaintainerListScreen';
import EditMaintainerScreen from './screens/EditMaintainerScreen';

function MaintainerInfo(props) {
    const { isMaintainerInfo } = props;
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<MaintainerListScreen />} />
                    <Route path={"/add"} element={<EditMaintainerScreen />} />
                    <Route path={"/:maintainerId/edit"} element={<EditMaintainerScreen />} />
                    <Route path="/:maintainerId" element={<MaintainerDetailScreen isMaintainerInfo={isMaintainerInfo} />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default MaintainerInfo;
